export default __webpack_public_path__ + "static/media/fa-solid-900.8fb677a9.ttf";